// extracted by mini-css-extract-plugin
module.exports = {"modalBackground":"Modal_modalBackground__3wqBh","modalCard":"Modal_modalCard__1KpTO","modalCloseButton":"Modal_modalCloseButton__2-8dz"};